import React from 'react';

export function ActionDataColumnFormatter(cellContent) {
  const payload = typeof cellContent?.payload === 'string' ? cellContent?.payload : '';
  return (
    <div>
      <div className={'text-dark-75 font-weight-bolder font-size-lg'}>
        {cellContent?.page}
      </div>
      <div className={'font-size-sm font-weight-bold'}>{cellContent?.subject}</div>
      <div
        title={payload}
        style={{maxWidth: 600}}
        className={'font-size-sm'}
      >
        {payload}
      </div>
    </div>
  );
}
